import React from 'react';
import { routes } from 'constants/config';
import { Spinner } from 'ui';
import { useFetch } from 'hooks';
import QuestionMetricsTableRow from './QuestionMetricsTableRow';
import ModuleLoadFailure from './ModuleLoadFailure';

const NonGradedQuestionPerformance = ({ lessonIdStr, currentGroupId }) => {
  const url = routes.LESSON_OVERVIEW.OPEN_ENDED_ELEMENTS(
    lessonIdStr,
    currentGroupId,
  );

  const { data, loading, error, runRequest } = useFetch(url);

  if (loading) return <Spinner />;
  if (error) {
    return <ModuleLoadFailure reload={runRequest} />;
  }
  const { questionMetrics } = data;
  return (
    <>
      <h2 className="SectionHeading">{t('lesson_performance.open_ended')}</h2>
      <section className="Module Module--bordered">
        <table className="PerformanceTable">
          <thead>
            <tr>
              <th className="PerformanceTable-rowHead">#</th>
              <th>{t('questions.title')}</th>
              <th>{t('answers.title')}</th>
            </tr>
          </thead>
          <tbody>
            {questionMetrics.map(questionMetric => (
              <QuestionMetricsTableRow
                key={questionMetric.question.id}
                questionMetric={questionMetric}
                lessonId={lessonIdStr}
                currentGroupId={currentGroupId}
              />
            ))}
          </tbody>
        </table>
      </section>
    </>
  );
};

export default props => <NonGradedQuestionPerformance {...props} />;
